import store from '@/store';
import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';

export interface SearchState {
  /** ページをまたぐ検索条件 */
  searchCondition: Array<SearchCondition>;
}

interface SearchCondition {
  [key: string]: any;
}

/**
 * 認証関連の状態管理クラス
 * このクラスの状態はリロードしても状態が保持される
 */
@Module({
  name: 'search',
  namespaced: true,
  dynamic: true,
  store,
  // ↓リロードしても状態を保持する場合に、この1行で追加制御が必要
  preserveState: sessionStorage.getItem('sample-ui') !== null
})
export class Search extends VuexModule implements SearchState {
  searchCondition: Array<SearchCondition> = [];

  /**
   * 検索条件を設定する
   *
   * @param conditions 格納検索条件
   */
  @Mutation
  setConditions(conditions: Array<{[k: string]: any}>) {
    this.searchCondition = conditions;
  }

  /**
   * HexabaseStateをリセットする
   */
  @Mutation
  clearsearchCondition() {
    this.searchCondition.splice(0)
  }
}

export default getModule(Search);
